export enum CustomerSearchOption {
    'customers' = 'Customer',
    'contracts' = 'Contract',
    'vehicles' = 'Vehicle' 
}
export enum CustomerPlaceholderTextOption{
    'customers' = 'Customer ID',
    'contracts' = 'Contract ID',
    'vehicles' = 'Vehicle VIN' 
}
export default interface ICustomerViewParams {
    idOption: keyof typeof CustomerSearchOption;
    id: string;
}